import { PublicClientApplication, type RedirectRequest } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_AD_REDIRECT_URI || "",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "email", "offline_access"],
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const OpenAPIBaseUrl = import.meta.env.VITE_OPENAPI_BASE_URL || "";
